import * as actionTypes from "../actions/actionType";

const initialState = {
  isMobile: false,
};

export const globalReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.SET_IS_MOBILE:
      return {
        ...state,
        isMobile: action.payload,
      };
    default:
      return state;
  }
};
